export enum EditorModes {
  edit,
  view,
}

export interface IH5PEditorState {
  showEditor: boolean;
  contentId?: string;
  loading: boolean;
  saving: boolean;
  content?: string;
  contentHash?: string;
  lastSavedContentHash?: string;
  exportLoading?: boolean;
  exportProgress?: number;
  downloadUrl?: string;
  showExportDialog?: boolean;
  mode: EditorModes;
}
